const PaeService = function ($q, paeFactory, accountService) {
    const service = this;
    //This calls the factory to get PAE user status.
    service.checkPaeUser = function () {
        const deferred = $q.defer();

        paeFactory.getCheckPaeUser.query(
            accountService.getActiveGroupAccount(),
            function (data) {
                deferred.resolve(data);
            },
            function (response) {
                deferred.reject();
            }
        );

        return deferred.promise;
    };
};

PaeService.$inject = ["$q", "paeFactory", "accountService"];
export default PaeService;
